import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';
import LoginPage from './pages/Login';
import Colors from './components/Colors';
import Header from './components/header';
import MainScreen from './pages/MainScreen';
import CustomersPage from './pages/Customers';
import ProductsPage from './pages/ProductsPage';
import EditProductPage from './pages/EditProductPage';
import AddProductPage from './pages/AddProduct';
import AddInvoicePage from './pages/AddInvoicePage';
import CustomerDetailsPage from './pages/CustomerDetailsPage';
import InvoiceDetailPage from './pages/InvoiceDetailPage';
import BillPage from './pages/BillPage';
import EditInvoicePage from './pages/EditInvoicePage';
import AddCustomer from './SheetContent/AddCustomer';
import BookerPage from './pages/BookerPage';
import RoutesPage from './pages/RoutesPage';
import EditFullInvoicePage from './pages/EditFullInvoice';
import CustomerReceivePage from './pages/CustomerReceivePage';

function App() {
  return (
    <Router>
      <div style={{background:Colors.backgroundLight, width:'100%',height:'auto',color:Colors.black}}>
        <Routes>
          <Route  path="/" element={<LoginPage/>}/>
          <Route path="/index" element={<MainScreen />} />
          <Route path="/customers" element={<CustomersPage />} />
          <Route path="/addcustomer" element={<AddCustomer />} />
          <Route path="/products" element={<ProductsPage />} />
          <Route path="/editproduct/:id" element={<EditProductPage />} />
          <Route path="/editinvoice/:id" element={<EditFullInvoicePage />} />
          <Route path="/customerlogs/" element={<CustomerReceivePage />} />
          <Route path="/addproduct" element={<AddProductPage />} />
          <Route path="/createinvoice" element={<AddInvoicePage />} />
          <Route path="/customer/:customerId" element={<CustomerDetailsPage />} />
          <Route path="/invoice/:invoiceId" element={<InvoiceDetailPage />} />
          <Route path="/bills" element={<BillPage />} />
          <Route path="/edit-invoice/:invoiceId" element={<EditInvoicePage />} />
          <Route path="/booker" element={<BookerPage />} />
          <Route path="/route" element={<RoutesPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
